import React, { useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { Form, Col, Row, Button, Alert } from "react-bootstrap";
import AuthHelper from "../../helpers/AuthHelper";
import aghub_logo from "../../images/aghub_logo_coop.png";
import VerificationPopUp from "./VerificationPopup";
import ForgotPasswordPopup from "./ForgotPasswordPopup";
import FluentdHelper from "../../helpers/FluentdHelper";
import {
  APP_VERSION,
  DANGER,
  EMPTY,
  FARMER,
  LOGERROR,
  LOGGING_IN,
  LOGIN,
  SESSION_EXPIRED,
  SESSION_EXPIRED_MESSAGE,
  USER_NOT_CONFIRMED_EXCEPTION,
  USER_POOL_GROUP,
} from "../../configurations/Constants";
import {
  ACCOUNT_DOES_NOT_EXIST,
  EMAIL_NOT_PRESENT_IN_DATABASE,
  ENTER_USERNAME,
  INVALID_CREDENTIALS,
  NOT_REGISTERED_CLICK_HERE,
  PLEASE_ENTER_PASSWORD,
} from "../../configurations/MessageConstants";
import { resetState } from "../../configurations/redux-configurations/actions/fieldAction";
import {
  setUserEmail,
  resetUserState,
} from "../../configurations/redux-configurations/actions/userAction";
import SessionHelper from "../../helpers/SessionHelper";
import { Link, Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import StorageHelper from "../../helpers/StorageHelper";
import LoadingOverlay from "../common/LoadingOverlay";

function Login(props) {
  const dispatch = useDispatch();
  const [username, setUsername] = useState(EMPTY);
  const [password, setPassword] = useState(EMPTY);
  const [redirect, setRedirect] = useState(false);
  const [showpassword, setShowpassword] = useState(false);
  const [validated, setValidated] = useState(false);
  const [invalidCredError, setInvalidCredError] = useState(false);
  const [btnLoginClick, setBtnLoginClick] = useState(false);
  const [showVerificationPopup, setShowVerificationPopup] = useState(false);
  const [showForgotPasswordPopup, setShowForgotPasswordPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState(EMPTY);

  const handleClick = async (event) => {
    StorageHelper.setItem(USER_POOL_GROUP, FARMER);
    dispatch(resetState());
    dispatch(resetUserState());
    SessionHelper.cleanUpStorageKeys();
    setBtnLoginClick(true);
    const form = event.currentTarget;
    const userEmail = username.toLowerCase().trim();
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
      setBtnLoginClick(false);
    } else {
      event.preventDefault();
      event.stopPropagation();
      setValidated(false);
      try {
        const response = await AuthHelper.SignIn(userEmail, password, false);
        dispatch(setUserEmail(userEmail));
        StorageHelper.setItem(LOGGING_IN, LOGIN + Math.random());
        StorageHelper.removeItem(LOGGING_IN);
        StorageHelper.removeItem(SESSION_EXPIRED);
        StorageHelper.removeItem(SESSION_EXPIRED_MESSAGE);
        FluentdHelper.logEvent(
          `User ${userEmail} successfully logged in to TPNRD.`,
          "handleClick_logInToAWSAmplify",
          userEmail,
          {
            request: {
              username: userEmail,
              password: Buffer.from(password).toString("base64"),
            },
            response: response,
          }
        );
        setRedirect(true);
      } catch (error) {
        let responseData = error.response.data;
        let errLogRequest = {
          username: userEmail,
          password: Buffer.from(password).toString("base64"),
        };

        if (responseData.message === EMAIL_NOT_PRESENT_IN_DATABASE) {
          setErrorMessage(ACCOUNT_DOES_NOT_EXIST);
          StorageHelper.removeItem(SESSION_EXPIRED);
          StorageHelper.removeItem(SESSION_EXPIRED_MESSAGE);

          FluentdHelper.logEvent(
            `The user email ${userEmail} does not exist in the postgres.`,
            "handleClick_logInToAWSAmplify",
            userEmail,
            { request: errLogRequest, response: error.response },
            LOGERROR
          );
          setInvalidCredError(true);
          setBtnLoginClick(false);
        } else if (responseData.message_code === USER_NOT_CONFIRMED_EXCEPTION) {
          FluentdHelper.logEvent(
            `User ${userEmail} is not confirmed.`,
            "handleClick_logInToAWSAmplify",
            userEmail,
            { request: errLogRequest, response: error.response },
            LOGERROR
          );
          setShowVerificationPopup(true);
          setBtnLoginClick(false);
        } else {
          setErrorMessage(INVALID_CREDENTIALS);
          FluentdHelper.logEvent(
            `Error while logging in to TPNRD for user ${userEmail}.`,
            "handleClick_logInToAWSAmplify",
            userEmail,
            { request: errLogRequest, response: null },
            LOGERROR
          );
          setInvalidCredError(true);
          setBtnLoginClick(false);
        }
      }
    }
  };

  const closePopUp = (e) => {
    setShowVerificationPopup(false);
    setShowForgotPasswordPopup(false);
  };

  const handleAfterVerified = () => {
    setShowVerificationPopup(false);
  };

  useEffect(() => {
    // ComponentDidMount
    const mainElement = document.getElementsByTagName("main")[0];
    const sectionElement = document.getElementsByTagName("section")[0];
    const widgetElement = document.getElementById("jsd-widget");

    if (mainElement) mainElement.style.height = "100%";
    if (sectionElement) sectionElement.style.height = "100%";

    if (widgetElement) {
      setTimeout(() => {
        widgetElement.style.opacity = "0";
      }, 300);
    }

    // ComponentWillUnmount
    return () => {
      const bodyElement = document.getElementsByTagName("body")[0];
      if (bodyElement) bodyElement.style.background = "#ffffff";
    };
  }, []);

  const toggleShowPassword = () => {
    setShowpassword(!showpassword);
  };

  const openForgotPassword = () => {
    setShowForgotPasswordPopup(true);
    return false;
  };

  if (redirect) {
    return <Navigate to="/dashboard" />;
  }
  return (
    <div className="h-100 position-relative">
      <LoadingOverlay
        showSpinner={true}
        active={btnLoginClick ? true : false}
        text="Logging in..."
      />
      <div className="d-flex align-items-center justify-content-center login flex-column">
        <Link
          to="/well-test-form"
          className="well-reports text-decoration-none"
        >
          Staff
        </Link>

        <div className="col-sm-8 col-md-6 col-lg-4">
          {StorageHelper.getItem(SESSION_EXPIRED) === "true" && (
            <Alert variant={DANGER} onClose={() => setInvalidCredError(false)}>
              {StorageHelper.getItem(SESSION_EXPIRED_MESSAGE)}
            </Alert>
          )}
          <figure className="text-center">
            <img src={aghub_logo} alt="Water Data Program" />
          </figure>

          <Form
            noValidate
            validated={validated}
            onSubmit={(e) => handleClick(e)}
            className=" mt-3"
          >
            {invalidCredError && (
              <Alert
                variant={DANGER}
                onClose={() => setInvalidCredError(false)}
                dismissible
              >
                {errorMessage}
              </Alert>
            )}
            <Form.Group
              as={Row}
              controlId="validationUsername"
              className="mb-3"
            >
              <Col>
                <Form.Control
                  type="email"
                  placeholder="Email"
                  name="username"
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {ENTER_USERNAME}
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            <Form.Group
              as={Row}
              controlId="formPlaintextPassword"
              className="mb-3"
            >
              <Col>
                <Form.Control
                  type={showpassword ? "text" : "password"}
                  placeholder="Password"
                  name="password"
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {PLEASE_ENTER_PASSWORD}
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="formPlaintext" className="mb-3">
              <Col>
                <Form.Check
                  type="checkbox"
                  label="Show Password"
                  onChange={() => {
                    toggleShowPassword();
                  }}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="formPlaintext" className="mb-3">
              <Col>
                <Button type="submit" className="mt-2" disabled={btnLoginClick}>
                  {btnLoginClick ? (
                    <div>
                      <Spinner
                        as="span"
                        animation="grow"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />{" "}
                      <span>Log In...</span>
                    </div>
                  ) : (
                    "Log In"
                  )}
                </Button>
              </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="formPlaintext" className="mb-3">
              <Col>
                <Button
                  variant="link"
                  className="text-muted link p-0 btn-link-small text-decoration-none"
                  onClick={(e) => openForgotPassword()}
                >
                  Forgot Password?
                </Button>
              </Col>
            </Form.Group>
          </Form>
        </div>
        <Link to="/register" className="register-link">
          {NOT_REGISTERED_CLICK_HERE}
        </Link>
        <VerificationPopUp
          showVerificationPopup={showVerificationPopup}
          userEmail={username.toLowerCase()}
          closeModal={(e) => closePopUp(e)}
          afterVerify={() => handleAfterVerified()}
        />
        <ForgotPasswordPopup
          showForgotPasswordPopup={showForgotPasswordPopup}
          closeModal={(e) => closePopUp(e)}
        />
      </div>
      <span className="app-version">Version {APP_VERSION}</span>
    </div>
  );
}

export default Login;
